module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch06"
    }
  }, [_c('b', [_vm._v("The Blues")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The term “feeling blue” has its roots in nautical traditions. In the old days, when a captain or officer died, the ship flew a blue flag.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("People sitting in the first few rows of a Blue Man Group concert get plastic ponchos before the show to protect them from the mess created as the performers bang on the liquid-filled tops of drums.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In many languages, people use the same word for the colors blue and green.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The sky is blue because of the way the human eye perceives color. On sunny days, light scatters in such a way that the eye “sees” only the blue part of the spectrum.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First official blues record: Hart A. Wand’s “Dallas Blues,” in 1912.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 2002’s "), _c('i', [_vm._v("Die Another Day")]), _vm._v(", James Bond sliced Thomas Gainsborough’s painting “The Blue Boy” with a sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The Toronto Blue Jays are the only Major League Baseball team located outside the United States.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("World’s largest blue sapphire: the Blue Giant of the Orient, at 466 carats.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Canada’s largest fruit crop: blueberries.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The term “blue jeans” comes from the French "), _c('i', [_vm._v("bleu de Gênes")]), _vm._v(", meaning “blue of Genoa.” Why? Some of the first denim pants were manufactured in Italy and were shipped out of the port of Genoa.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Bluebirds were considered a rare species until 1996.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba4235e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter06.vue
// module id = 90
// module chunks = 0